import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

const AdminActionConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel = "تأیید",
  confirmColor = "primary",
  showNotes = true,
  notesLabel = "توضیحات (اختیاری)",
  saving = false,
  onClose,
  onConfirm,
}) => {
  const [notes, setNotes] = useState("");

  useEffect(() => {
    if (open) setNotes("");
  }, [open]);

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {description ? (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        ) : null}
        {showNotes ? (
          <TextField
            fullWidth
            multiline
            minRows={2}
            label={notesLabel}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            sx={{ mt: 2 }}
            disabled={saving}
          />
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          انصراف
        </Button>
        <Button
          variant="contained"
          color={confirmColor}
          disabled={saving}
          onClick={() => onConfirm(showNotes ? notes : undefined)}
        >
          {saving ? <CircularProgress size={22} color="inherit" /> : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdminActionConfirmDialog;
